import React from 'react'

export default ({ text, subText, isCollapsed }) => (
    <div className={ isCollapsed ? `is-collapsed` : `chartMessageWrapper` }>
        <div className="chartMessageText">
            {text}
        </div>
        {subText ? <div className="chartMessageSubtext">{subText}</div> : null}
    </div>
)